import { createSlice } from "@reduxjs/toolkit";

const surveyNameSpaceSlice = createSlice({
  name: "surveyNameSpace",
  initialState: "personaSurveyUS",
  reducers: {
    setSurveyNameSpace(state = "", action) {
      return action.payload || state;
    },
  },
});

export const { setSurveyNameSpace } = surveyNameSpaceSlice.actions;

export default surveyNameSpaceSlice.reducer;
